export interface IFaq {
  faqId: string;
  faqGroupId: string;
  question: string;
  answer: string;
  videoUrl?: string;
  status: boolean;
  sortOrder: number;
  uidCreatedBy?: string;
  uidUpdatedBy?: string;
  createdAt: string;
  updatedAt: string;
}

export class Faq {
  faqId: string;
  faqGroupId: string;
  question: string;
  answer: string;
  videoUrl?: string;
  status: boolean;
  sortOrder: number;
  uidCreatedBy?: string;
  uidUpdatedBy?: string;
  createdAt: Date;
  updatedAt: Date;

  constructor(data: IFaq) {
    this.faqId = data.faqId;
    this.faqGroupId = data.faqGroupId;
    this.question = data.question;
    this.answer = data.answer;
    this.videoUrl = data.videoUrl;
    this.status = data.status;
    this.sortOrder = data.sortOrder;
    this.uidCreatedBy = data.uidCreatedBy;
    this.uidUpdatedBy = data.uidUpdatedBy;
    this.createdAt = new Date(data.createdAt);
    this.updatedAt = new Date(data.updatedAt);
  }
}
